import request from "oc-request";

function applyTranslator(event) {
    event.preventDefault();

    request.sendData('localePicker::onSwitchLocale', {
        data: {
            locale: this.dataset.value,
        },
        success: (response) => {
            console.log(response);
        },
    });
}

function init() {
    // ищем кнопку, при нажатии на которую применяем фильтр
    const applyBtns = document.querySelectorAll(`[data-translator-btn]`);

    if (applyBtns) {

        applyBtns.forEach(function (applyBtn){
            applyBtn.addEventListener('click', applyTranslator, false); // для ЖК тут будет 'change' и следить надо будет за инпутами, а не одной кнопкой
        })
    }
}

init();
